import React from "react";
import { MILITARY, SHOTS } from "../mock";
import DeviceFrame from "./renn/DeviceFrame";
import Reveal from "./Reveal";

const Military = () => {
  return (
    <section id="military" className="relative py-20 lg:py-28">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal delay={100} className="order-2 lg:order-1 flex justify-center lg:justify-start">
          <DeviceFrame src={SHOTS.settings} alt="Renn settings and profile screen" className="w-full max-w-[360px]" />
        </Reveal>

        <Reveal className="order-1 lg:order-2">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Military</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {MILITARY.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8] leading-relaxed">{MILITARY.copy}</p>

          <div className="mt-7 flex flex-wrap gap-2">
            {MILITARY.audience.map((a) => (
              <span key={a} className="text-sm font-medium text-[#13D99A] rounded-full border border-[#10C98A]/40 bg-[#10C98A]/10 px-3.5 py-1.5">
                {a}
              </span>
            ))}
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {MILITARY.topics.map((t) => (
              <span key={t} className="text-sm text-[#8290A8] rounded-full border border-[#29354A] bg-[#121A28] px-3.5 py-1.5">
                {t}
              </span>
            ))}
          </div>

          <p className="mt-8 font-display text-lg font-semibold text-[#F5F7FB]">{MILITARY.line}</p>
          <p className="mt-4 text-xs text-[#8290A8]/80 leading-relaxed">{MILITARY.disclaimer}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default Military;
